export default "__VITE_ASSET__2b435753__"